import { Icon24Done } from '@vkontakte/icons';
import { Image, RichCell, Text } from '@vkontakte/vkui';
import { useStoreMap, useUnit } from 'effector-react';
import { memo } from 'react';
import { $currentNominationName, $secondStageVotes, INominee } from 'src/entity/Pretendents';
import { classNames } from 'src/shared/lib/helpers/classNames';
import styles from './styles.module.scss';

export interface ISecondStageVoitingCard extends INominee {
  image: string;
}

export const SecondStageVoitingCard = memo(
  ({
    nomineeId,
    nomineeLabel,
    image
  }: ISecondStageVoitingCard) => {
    const [
      currentNominationName
    ] = useUnit([
      $currentNominationName
    ]);

    const currentChoose = useStoreMap({
      store: $secondStageVotes,
      fn: secondStageVotes => {
        if (!currentNominationName) return false;
        return secondStageVotes?.[currentNominationName] === nomineeId;
      },
      keys: []
    });

    if (!currentNominationName || !nomineeId) return null;

    return (
      <RichCell
        disabled
        multiline
        className={
          currentChoose
            ? classNames(styles.cell, {}, [styles.currentChoose])
            : styles.cell
        }
        before={(
          <Image
            size={96}
            src={image}
          />
        )}
        after={currentChoose && <Icon24Done className={styles.icon} />}
      >
        <Text weight='2' className={styles.title}>
          {nomineeLabel}
        </Text>
      </RichCell>
    );
  }
);
